import { render, staticRenderFns } from "./productSpecification_2021.vue?vue&type=template&id=4fed699e&scoped=true&"
import script from "./productSpecification_2021.vue?vue&type=script&lang=js&"
export * from "./productSpecification_2021.vue?vue&type=script&lang=js&"
import style0 from "./productSpecification_2021.vue?vue&type=style&index=0&id=4fed699e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fed699e",
  null
  
)

export default component.exports